import React from 'react'; 
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/book-quantity/add'; 

class UpdateBook extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            quantity:'', 
            preloader:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let params={
                quantity:this.state.quantity,
                book_id:this.props.match.params.id,
            };
            processData(Url,params).then((res)=>{
                if(res.data.status===200){
                    this.back();
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    } 
    back=()=>{
        this.props.history.goBack();
    }
 
  
    render() {
        let {title,preloader,quantity} = this.state;
        let role=permissionCheck('book',title);
        if(!role)
            return <Nopermission/>;
        const quantityValid= this.validator.message('Quantity',quantity, 'required|numeric');
        return (
            <div id="page_content_inner" className="uk-width-medium-4-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">Add Book Quantity</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${quantity ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Quantity<span className="req">*</span></label>
                                    <input type="text" name="quantity" value={quantity} onChange={this.setStateFromInput} className={ `md-input ${quantityValid ?'md-input-danger':''}`} /> 
                                    {quantityValid} 
                                </div>
                            </div>
                        </div> 
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1">
                                <button type="button" onClick={()=>this.back()} className="md-btn md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</button>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default UpdateBook;


// WEBPACK FOOTER //
// ./src/components/Library/Book/UpdateBook.js